import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Footer.module.css';
import OwlImage from './bkg-owl.png';

function Footer() {
  return (
    <footer className={styles['footer']}>
      <div className={styles['footer-inner']}>
        <div className={styles['footer-grid']}>
          <div className={styles['brand-col']}>
            <Link to="/" className={styles['brand']}>
              <span aria-hidden="true" className={styles['brand-owl']} style={{ '--owl-src': `url(${OwlImage})` }} />
              <div className={styles['brand-stack']}>
                <span className={styles['brand-wordmark']}>
                  Policy Pulse <span className={styles['brand-accent']}>Institute</span>
                </span>
                <span className={styles['brand-motto']}>
                  P<span className={styles['motto-tail']}>rimum</span> N<span className={styles['motto-tail']}>on</span> D<span className={styles['motto-tail']}>esipere</span>
                </span>
              </div>
            </Link>
          </div>

          <div className={styles['col']}>
            <div className={styles['col-h']}>About</div>
            <ul>
              <li><Link to="/what-we-do">What We Do</Link></li>
              <li><Link to="/about#team">Our Team</Link></li>
            </ul>
          </div>

          <div className={styles['col']}>
            <div className={styles['col-h']}>Contact</div>
            <ul>
              <li>
                <a href="mailto:contact@policypulse.institute">
                  contact@policypulse.institute
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className={styles['rights']}>
          <span>© {new Date().getFullYear()} POLICY PULSE INSTITUTE</span>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
